<template>
  <div class="main-wrapper">
    <layout-sidebar />
    <main class="page-wrapper">
      <router-view />
    </main>
    <testpal-ai-chatbox />
  </div>
</template>

<script>
import LayoutSidebar from '@/views/layouts/layout-sidebar.vue'
import TestpalAiChatbox from '@/components/testpal-ai-chatbox.vue'

export default {
  name: 'MainLayout',
  components: {
    LayoutSidebar,
    TestpalAiChatbox
  }
}
</script>

<style scoped>
.main-wrapper {
  min-height: 100vh;
  background: #f8fafc;
}

.page-wrapper {
  margin-left: clamp(72px, 6vw, 88px);
  padding: 16px 20px;
  min-height: 100vh;
}

@media (max-width: 768px) {
  .page-wrapper {
    margin-left: 0;
    padding: 72px 16px 16px;
  }
}

@media (min-width: 1200px) {
  .page-wrapper {
    padding: 20px 28px;
  }
}

:global(body.dark-mode) .main-wrapper {
  background: #111827;
}
</style>
